import React from 'react';
import SummaryCoverImage from './SummaryCoverImage';
import SummaryDetails from './SummaryDetails';
import { MindItem } from '@klab-berlin/api-sdk/lib/types/responses/MindItem';
import { Product } from '@klab-berlin/api-sdk/lib/types/responses/Product';
import { Box, Theme, useMediaQuery } from '@mui/material';
import useScreenSize from '../../utils/useScreenSize';
import { spaces } from '../../assets/styles/themes/tokens';

const SummaryContent: React.FC<{
  itemData: Partial<Product> | Partial<MindItem>;
  isLoading: boolean;
  primaryHeaderText: string;
  secondaryHeaderText?: string;
  alignDetailsToBottom?: boolean;
}> = ({
  itemData,
  isLoading,
  primaryHeaderText,
  secondaryHeaderText,
  alignDetailsToBottom,
  children,
}) => {
  const { isMediumScreen } = useScreenSize();
  const flexDirectionBreakPoint = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: flexDirectionBreakPoint ? 'column' : 'row',
        gap: isMediumScreen ? spaces.md : spaces.xl,
      }}
    >
      <SummaryCoverImage
        isNew={itemData.isNew}
        coverImage={itemData.thumbnail}
        isLoading={isLoading}
      />
      <SummaryDetails
        itemData={itemData}
        primaryHeaderText={primaryHeaderText}
        secondaryHeaderText={secondaryHeaderText}
        alignToBottom={alignDetailsToBottom}
      >
        {children}
      </SummaryDetails>
    </Box>
  );
};

export default SummaryContent;
